import React from "react";
import styled from "styled-components";
import classnames from "classnames";
import { TooltipTrigger } from '../../../Tooltip/Tooltip';
import useLanguage from "../../../../utilities/useLanguage";
import { getTranslation } from "../../translations";
import { createDataTestId, AutomationTestIdFeature, AutomationTestIdElementType } from "../../../../utilities/automation"
import InputSlider from "../../basics/InputSlider";
import InfoIcon from "../../common/info-icon.svg";
import { ICalculatedRate } from "../../models/IRate";

interface IRateBoxProps {
    selectedRate: ICalculatedRate;
    className: string;
    handleInputSliderChange: () => {}
}

export default styled(({ selectedRate, className, handleInputSliderChange }: IRateBoxProps) => {
    const { lang } = useLanguage();
    const disclosureData = (lang === 'es' && selectedRate.rate.product.disclosure.spanishDisclosureData) ? selectedRate.rate.product.disclosure.spanishDisclosureData : selectedRate.rate.product.disclosure.disclosureData;

    return (
        <div className={classnames(className)}
            data-test-id={createDataTestId({feature: AutomationTestIdFeature.MRQT_CALCULATOR, element: AutomationTestIdElementType.COLLECTION_ITEM, specifier: 'rate_row'})}
            data-loan-balance={selectedRate.rate.disclosureInformation.balance}
            data-loan-property-amount={selectedRate.rate.disclosureInformation.propertyAmount}
            data-loan-name={selectedRate.name}>
            <div className="legend">{getTranslation(lang).rate}</div>
            <div className="mb-3 d-flex">
                <strong className="rate"><span className="rate-value">{selectedRate.modifiedInitialRate.toFixed(3)}</span> (<span className="apr-value">{selectedRate.modifiedApr.toFixed(3)}</span> {getTranslation(lang).apr})</strong>
                <TooltipTrigger className="tooltip-trigger ml-1" html={disclosureData} place="right"><img src={InfoIcon} /></TooltipTrigger>
            </div>
            <InputSlider onChange={handleInputSliderChange} />
        </div>
    );
})`
    position: relative;
    border-radius: 2px;
    background: rgba(193, 186, 182, 0.40);
    padding: 1.5rem 1rem;
    margin-top: 2rem;

    @media (min-width: 992px) {
        border-radius: 8px;
    }

    .row {
        line-height: 1rem;
    }

    .legend {
        font-size: 0.77778rem;
        font-weight: 400;
        line-height: 1rem;
    }

    .rate {
        font-size: 1.33333rem;
        font-weight: 700;
        line-height: 1.51561rem;
    }
`;